define([
    'text!./templates/faq.html',
    './FaqCtrl'
], (FaqTemplate, FaqCtrl) => {
    return () => {
        return {
            restrict: 'E',
            template: FaqTemplate,
            controller: FaqCtrl
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/faq/FaqDirective.js